export default {
  clients: [],
  client: null,
  pagination: {},
  clientToUpdate: null,
  homeData: {}
};
